"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Github, Linkedin, Twitter, Send, Loader } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const defaultLinks = [{
    id: "1",
    label: "Web Development",
    href: "/ServicesPage"
  }, {
    id: "2",
    label: "Social Management",
    href: "/ServicesPage"
  }, {
    id: "3",
    label: "Branding",
    href: "/ServicesPage"
  }, {
    id: "4",
    label: "Home",
    href: "/HomePage"
  }, {
    id: "5",
    label: "Services",
    href: "/ServicesPage"
  }, {
    id: "6",
    label: "Start Project",
    href: "/StartYourProjectPage"
  }, {
    id: "7",
    label: "Privacy Policy",
    href: "#"
  }, {
    id: "8",
    label: "Terms of Service",
    href: "#"
  }];
  const itemsToRender = menuItems && menuItems.length > 0 ? menuItems : defaultLinks;
  const midPoint = Math.ceil(itemsToRender.length / 2);
  const col1Items = itemsToRender.slice(0, midPoint);
  const col2Items = itemsToRender.slice(midPoint);
  if (loading) {
    return <>
        <div data-section-id="3032" className="space-y-4">
          {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-24 bg-muted animate-pulse rounded" data-index={i} />)}
        </div>
        <div className="space-y-4">
          {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-24 bg-muted animate-pulse rounded" data-index={i} />)}
        </div>
      </>;
  }
  return <>
      {}
      <div className="flex flex-col space-y-3">
        <h3 className="text-[10px] font-mono font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-2">
          Expertise
        </h3>
        <ul className="space-y-2">
          {col1Items.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-[10px] font-mono text-muted-foreground transition-colors duration-300 hover:text-white hover:drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>

      {}
      <div className="flex flex-col space-y-3">
        <h3 className="text-[10px] font-mono font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-2">
          Studio
        </h3>
        <ul className="space-y-2">
          {col2Items.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-[10px] font-mono text-muted-foreground transition-colors duration-300 hover:text-white hover:drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>
    </>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-4 rounded-none bg-white/5 border border-white/10 text-white text-[10px] font-mono animate-in fade-in slide-in-from-bottom-2">
        {successMessage}
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-3">
      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <div className="relative group">
                <Input placeholder="DIGITAL INSIGHTS EMAIL" type="email" className="pr-12 bg-transparent border-b border-t-0 border-l-0 border-r-0 border-white/20 rounded-none focus-visible:border-white focus-visible:ring-0 transition-all duration-500 placeholder:text-muted-foreground/40 font-mono text-[10px]" {...field} />
                <Button type="submit" size="icon" disabled={isSubmitting} className="absolute right-0 top-0 h-full w-10 rounded-none bg-transparent text-muted-foreground hover:text-white hover:bg-transparent shadow-none">
                  {isSubmitting ? <Loader className="size-4 animate-spin" /> : <Send className="size-4" />}
                  <span className="sr-only">Join</span>
                </Button>
              </div>
            </FormControl>
            <FormMessage className="text-[10px] font-mono" />
          </FormItem>} />
      {submitError && <p className="text-[10px] font-mono text-destructive mt-1">{submitError}</p>}
      <p className="text-[10px] font-mono text-muted-foreground/60">
        Stay updated with our latest cinematic productions.
      </p>
    </Form>;
}
export default function PulseMetricsFooter() {
  const currentYear = new Date().getFullYear();
  return <footer id="moondos-footer" className="dark bg-black text-white border-t border-white/5 relative overflow-hidden after:content-['MOONDOS'] after:absolute after:bottom-[-0.35em] after:left-1/2 after:-translate-x-1/2 after:text-[22vw] after:font-black after:text-white/[0.03] after:tracking-tighter after:pointer-events-none">
      <div className="container mx-auto px-4 py-16 relative z-10">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col space-y-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575318/img/moondos_logo_white.png" alt="Moondos Media" className="h-6 w-auto object-contain opacity-90" />
            </Link>
            <p className="text-muted-foreground text-[10px] font-mono leading-relaxed max-w-xs uppercase tracking-wider">
              High-end digital media and branding. Elevating athletes, influencers, and brands through cinematic storytelling.
            </p>
            
            {}
            <div className="flex items-center gap-4 pt-2">
              {[{
              icon: Twitter,
              href: "https://twitter.com",
              label: "X"
            }, {
              icon: Github,
              href: "https://instagram.com",
              label: "Instagram"
            }, {
              icon: Linkedin,
              href: "https://linkedin.com",
              label: "LinkedIn"
            }].map((social, i) => <Link key={i} to={social.href} newTab className="text-muted-foreground transition-all duration-500 hover:text-white hover:drop-shadow-[0_0_12px_rgba(255,255,255,0.4)] transform hover:-translate-y-0.5" aria-label={social.label} data-index={i}>
                  <social.icon className="size-4" strokeWidth={1} />
                </Link>)}
            </div>
          </div>

          {}
          <MenuProvider menu_id="17" className="contents">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex flex-col space-y-4">
            <h3 className="text-[10px] font-mono font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-2">
              Connect
            </h3>
            <FormProvider formId="newsletter-footer" sectionName="footer" defaultValues={{
            email: ""
          }} submitText="Join" successMessage="Welcome to the inner circle.">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>

        <Separator className="bg-white/5" />

        {}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] font-mono text-muted-foreground/40 uppercase tracking-widest">
          <p>
            &copy; {currentYear} Moondos Media. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-white transition-colors duration-300">
              Privacy
            </Link>
            <Link to="#" className="hover:text-white transition-colors duration-300">
              Terms
            </Link>
            <Link to="#" className="hover:text-white transition-colors duration-300">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}